<template>
     <div class="wrap">
        <div class="wrap_inner">
            <div class="wrap_main">
                <div class='mainlist'>
					<div @click="goBack" class="imgp"><van-icon name="arrow-left" /></div>
					<div class="bmk">
						
						<div class="bmk1">
							<div class="bmkImg"><img src="./image/noticeTop.png"></img></div>
						    <div class="bmkContent" style="position:absolute;top:0;left:0;width:100%;height:100%"><div>{{dataList.noticeTitle}}</div>
						   <div class="innerSub" style="display:flex">
							 <div class="sName" style="flex:1"><span>{{dataList.createTime}}</span><span style="margin-left:15px">{{dataList.createBy}}</span></div>
							 <!-- <div class="stime" style="flex:1"></div> -->
							 <!-- <div class="stime mName">发布时间:<span>{{dataList.createTime}}</span></div> -->
							 <!-- <div class="stime" style="flex:1">浏览量:<span>1111121112</span></div> -->
						   </div> </div>
						</div>
					</div>
					<div class="pannels">
						<div class="pannelsy" style="overflow: hidden;height: 100%;">
							<div class="mSty" style="word-wrap:break-word" v-html="htmlChange()">
									<!-- {{dataList.noticeContent}} -->
							</div>
						</div>
						<!-- <div style="width:100%;display:flex;flex-wrap: wrap;">
							<div class="uSty" v-for="(item,index) in data">
									<img :src="item.img" class="imgun">
								
							</div>
						</div> -->
						<!-- <div class="tfEng">
							<div class="tftit"><img src="./image/-@2x.png" style="flex:1"></div>
							<div class="tfInner"><div class="tftxt">标题标题标题标题标题标题标题标题</div><div class="tfrate">(12k)</div></div>
							<div class="download">下载</div>
						</div> -->
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
    export default{
		data(){
			return {
				dataList:{},
			}
		},
		methods:{
			goBack(){
				this.$router.push('/mine')
			},
			htmlChange(){
				if(this.dataList.noticeContent){
					return this.dataList.noticeContent
					// return '<b>aaaaaa</b><img src="http://222.73.134.202:8092/profile/upload/2021/06/25/1.jpg"></img>aaaaaa'
				}
			},
			getNotice(){
			   let data={}
			   this.$api.post('/app/notice/getNoticeKind',data).then(res=>{
					  if(res.data.code=="0000"){
						   if(res.data.data){
							   let data=res.data.data;
							   this.dataList=data
								this.dataList.createTime=this.dataList.createTime
								this.dataList.createBy=this.dataList.createBy
								console.log(this.dataList.noticeContent)
						   }
					  }
				   }
			   )
			},
		},
		created(){
			this.getNotice()
		},
		mounted(){
			this.getNotice()
		}
    }
</script>
<style scoped>
	
	
	.wrap{
	        position: absolute;
	            top: 0;
	            left:0;
	            /* z-index:1000; */
	            width:100%;
	            height:100%;
	            overflow: auto;
	            background:#e9eef2;
				overflow-x:hidden;
				background: linear-gradient(90deg,#36b3fe, #0080ff);
	    }
	    .wrap_inner{
	         min-height: 100%;
	         width:100%;
	    }
	    .wrap_main{
			position:absolute;
			width:100%;
			height:100%;
			box-sizing:border-box;
			padding-bottom: 70px;
	    }
		
/* 	.wrap{
	        position: absolute;
	        top: 0;
	        left:0;
	        z-index:1000;
	        width:100%;
	        height:100%;
	        overflow: auto;
			overflow-x:hidden;
	        background:#e9eef2;
			background: linear-gradient(90deg,#36b3fe, #0080ff);
	    }
	    .wrap_inner{
	         min-height: 100%;
	         width:100%;
			 
	    }
	    .wrap_main{
	        padding-bottom: 0px;
	    } */
	.mainlist{
	    width:100%;
	    height:100%;
	}
   .bmk{
	   width:335px;;
	   height:67px;
	   text-align:left;
       font-size: 20px;
       font-weight: 400;
       color: #333333;
	   margin:16px auto;
	   margin-top:51px;
   }
   .imgp{
	   position:absolute;
	   top:8px;
	   left:9px;
	   width:22px;;
	   height:22px;
       color:#fff;
       font-size:25px;
   }
   .bmk1{
	   position:relative;
   	   width:100%;
   	   height:67px;
	   padding:11px 16px;
   	   text-align:left;
       font-size: 20px;
       font-weight: 400;
       color: #333333;
   	   margin:17px auto;
	   box-sizing: border-box;
	   /* background:#fff; */
	   border-radius: 4px;
	   box-shadow: 0px 3px 6px 0px rgba(16,82,139,0.16);
   }
   .bmkContent{
   	 padding: 11px 16px;
   	 box-sizing: border-box;
   }
   .bmkImg {
      position:absolute;
      top:0;
      left:0;
      width:100%;
      height:87px;
   }
   .bmkImg img{
      width:100%;
      height:87px;
   }
   .uSty{
	   display:flex;justify-content:center;align-items:center;flex:0 0 33.3333333%;height:90px;
   }
   .pannels{
	   position: relative;
	   width:335px;
	   margin:0 auto;
	   /* background:#fff; */
	   padding:19px 0;
	   height: calc(100% - 130px);
	   overflow: hidden;
	   text-indent:32px;
	   line-height:28px;
	   font-size: 14px;
	   font-weight: 400;
	   text-align: left;
	   color: #333333;
	   box-sizing: border-box;
	   margin-bottom:70px;
	   border-radius: 4px;
	   box-shadow: 0px 3px 6px 0px rgba(16,82,139,0.16);
	   overflow: auto;
	   background-image: url('./image/noticeBottom.png');
	   background-size: 100% 100%;
   }
   .pannelsy{
	   width: 100%;
	   height: 100%!important;
	   box-sizing: border-box;
   }
 .pannels /deep/ video.edui-upload-video.vjs-default-skin.video-js{
	   width:300px!important;
   }
   .pannels /deep/ img{
   	   width:300px!important;
     }
   .mSty{
	   margin:0px auto;
	   /* position: absolute;
	   top: 0;
	   left: 0; */
	   width: 100%;
	   padding:0 16px;
	   /* padding:30px 15px 15px 15px; */
	   box-sizing: border-box;
	   overflow: auto;
	   /* height: 100%; */
	   height:100%;
	  
	}
   .innerSub{
	   margin-top:6px;
   }
   .sName{
	   overflow:hidden;
	   　　text-overflow:ellipsis;
	   　　white-space:nowrap;
	   font-size:12px;
	   color: #666666;
   }
   .stime{
	   overflow:hidden;
	   　　text-overflow:ellipsis;
	   　　white-space:nowrap;
	   font-size:12px;
	   color: #666666;
   }
   .mName{
	   flex:0 0 120px
	}
	.imgun{
		flex:0 0 80px;height:80px;
	}
	.tfEng{
		margin:40px auto;width:100%;height:45px;line-height:45px;display:flex;justify-content:center;align-items:center;
	}
	.tftit{
		display:flex;justify-content:center;align-items:center;flex:0 0 15px
	}
	.tfInner{
		display:flex;flex:1;width:100%;height:45px;text-indent:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding:0 10px;
	}
	.tftxt{
		flex:0 0 200px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;
	}
	.tfrate{
		flex:1;font-size: 14px;font-weight: 500;text-align: left;color: #999999;
	}
	.download{
		flex:0 0 40px;height:45px;line-height:45px;text-indent:0;font-size: 14px;font-weight: 500;text-align: left;color: #0080ff;
	}
</style>
